/**
 * @generated SignedSource<<d9fbd32ab3c342de70a64ef96ebbdbe8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileUnmatchButton_match$data = {
  readonly profile: {
    readonly name: string;
  } | null | undefined;
  readonly rowId: any;
  readonly " $fragmentType": "ProfileUnmatchButton_match";
};
export type ProfileUnmatchButton_match$key = {
  readonly " $data"?: ProfileUnmatchButton_match$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileUnmatchButton_match">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileUnmatchButton_match",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "Match",
  "abstractKey": null
};

(node as any).hash = "0eaf3eded46905069bcf47ddb88c4111";

export default node;
